import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import * as Urql from '@/utils/urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type SetUserLanguageMutationVariables = Types.Exact<{
  input: Types.SetUserLanguageInput;
}>;


export type SetUserLanguageMutation = { setUserLanguage: { success?: boolean | null } };


export const SetUserLanguageDocument = /*#__PURE__*/ gql`
    mutation setUserLanguage($input: SetUserLanguageInput!) {
  setUserLanguage(input: $input) {
    success
  }
}
    `;

export function useSetUserLanguageMutation() {
  return Urql.useMutation<SetUserLanguageMutation, SetUserLanguageMutationVariables>(SetUserLanguageDocument);
};